// extracted by mini-css-extract-plugin
export default {"cls1":"QSIdvKfABIcOgy4Ghiay","cls2":"Bgy1oQlgIOgZCOQelCnO QSIdvKfABIcOgy4Ghiay","isTabletDown":"IywAD186RkyefszMrBoV","isDesktopUp":"J81qjVDDpBMBfWGAssuz"};